import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd, Event, ActivatedRoute } from '@angular/router';
import { SignInfoService } from 'services/sign-info/sign-info.service';
import { AuthService } from 'services/auth/auth.service';

@Component({
	selector: 'app-display',
	templateUrl: './display.component.html',
	styleUrls: ['./display.component.css']
})
export class DisplayComponent implements OnInit {
	signGroupNames: any[] = new Array();

	route;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private signInfoService: SignInfoService,
		private authService: AuthService
	) {
		router.events.subscribe((event: Event) => {
			if (event instanceof NavigationEnd) {
				this.route = event.url;
			}
		});
	}

	ngOnInit() {
		this.signInfoService
			.getByValue('groups/username', this.authService.currentUser.username)
			.subscribe((result) => {
				this.signGroupNames = result;
				let group = this.activatedRoute.snapshot.queryParams['redirectGroup'];
				if (this.router.url === '/display') {
					this.router.navigate(['/display/' + this.signGroupNames[0].Name]);
				} else if (group && this.signGroupNames.filter((g) => g.Name === group)) {
					this.router.navigate(['/display/' + group]);
				}
				// console.log(this.signGroupNames);
			});
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/display/display.component.ts